<template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
        <el-tab-pane :disabled="!isover" label="施工队列表" name="first"></el-tab-pane>
        <el-tab-pane :disabled="!isover" label="施工队员列表" name="second"></el-tab-pane>
        <el-tab-pane :disabled="!isover" label="费用单列表" name="third"></el-tab-pane>
        <el-tab-pane :disabled="!isover" label="导入记录" name="four"></el-tab-pane>
        <el-tab-pane :disabled="!isover" label="应收款报表" name="five"></el-tab-pane>
        <el-tab-pane :disabled="!isover" label="实发报表" name="six"></el-tab-pane>
    </el-tabs>
</template>
<script>
import xz from "./../../../common.vue";
export default{
    props: {
        listQuerys: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    // props:["listQuerys"],
    data() {
        return{
            activeName:'first',
            isover:true,
            roleType: localStorage.loginRoletype,
            numQuery:{
                StrnowState:'已报名', //状态
                strProjectName:'', // 项目名称
                strUserName:'', // 姓名
                strMobile:'', // 联系方式
                strJobInf:'', //岗位
                strSource:'', //来源
                strreuser:'', //招聘顾问
                strUserkf:'', //客服
                stroutid:'', //导出选中id
                currpage: 1, // 分页
                perpage: 10,
                strSourcejl:'',//简历来源
                posCategoryList:[],//意向岗位
                jobList:[],// 人岗匹配岗位
                roletype: localStorage.loginRoletype
            }
        }
    },
    created(){
        // console.log('yy',this.listQuerys)
        if(!this.isNull(this.$route.query.active)){
            this.activeName = this.$route.query.active
        }else{
            this.activeName = 'first'
        }
        // if(location.pathname.indexOf('/supplierManage')>-1){
        //     this.numQuery = this.listQuerys
        //     this.numQuery.currpage = 1
        // }
        // 向父组件传值
        this.$emit('change', this.activeName);
    },
    watch: {
        '$store.state.supComTabsIsover': function () {
        this.isover = this.$store.state.supComTabsIsover
        //   console.log('d',this.isover)
        }
    },
    methods:{
        handleClick(tab, event) {
            // 向父组件传递了两个值
            this.$emit('change', tab.name);
            // this.numQuery = this.listQuerys
            // this.numQuery.currpage = 1
            if(tab.name == 'first'){
                this.$router.push({
                    path: '/supplierManage?active=first'
                })
            }else if(tab.name == 'second'){
                this.$router.push({
                    path: '/teamMembers?active=second'
                })
            }else if(tab.name == 'third'){
                this.$router.push({
                    path: '/supFeeList?active=third'
                })
            }else if(tab.name == 'four'){
                this.$router.push({
                    path: '/supplyLog?active=four'
                })
            }else if(tab.name == 'five'){
                this.$router.push({
                    path: '/receivablesReport?active=five'
                })
            }else if(tab.name == 'six'){
                this.$router.push({
                    path: '/generatedRecords?active=six'
                })
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>
